export const setToMap = (
  map: Map<string, any[]>,
  key: string,
  value: any
): void => {
  map.set(key, [...map.get(key), value]);
};

export const isInMap = ( map: Map<string, any[]>, key: string) : boolean => {
  return !!map.get(key)
}
